export default "__VITE_ASSET__DWedBcmV__"